import { PickPublic } from '../lib/utils.ts'
import { HttpClient } from './httpClient.ts'
import { Vocabulary } from './vocabApi.ts'

interface VocabularyResponse {
  count: number
  next: string | null
  previous: string | null
  results: Vocabulary[]
}

export interface IGraphElement {
  count: number
  delta: number
  range_end: string
  range_start: string
  ratio: number
}

export interface VocabularyStat {
  new: number
  weak: number
  strong: number
  total: number
  graph: IGraphElement[]
}

export type PracticeApi = PickPublic<AppPracticeApi>
export class AppPracticeApi {
  constructor(private httpClient: HttpClient) {}

  async getPracticePrograms(courseId?: number | null) {
    const params = new URLSearchParams()
    if (courseId != null) params.set('course_id', String(courseId))
    const url =
      '/api/user_practice/' +
      (params.toString() ? `?${params.toString()}` : '')
    return await this.httpClient.get(url)
  }

  async getCount(courseId?: number | null) {
    const params: Record<string, string | number> = { limit: 1 }
    if (courseId != null) params.course_id = courseId
    const result = await this.httpClient.get<VocabularyResponse>(
      '/api/vocabulary/',
      params,
    )
    return result.count
  }
  async getVocabStat(courseId?: number | null) {
    const params: Record<string, string | number> = {}
    if (courseId != null) params.course_id = courseId
    return await this.httpClient.get<VocabularyStat>(
      '/api/vocabulary/stat/',
      params,
    )
  }
}
